import { ConfirmSheet } from '@/components/ConfirmSheet'
import {
  ModalSheetContentBlock,
  ModalSheetContentDescription,
  ModalSheetContentIllustration,
  ModalSheetContentTitle,
} from '@/components/ModalSheet'
import { byDesign } from '@/infra/design'
import imgRemoveCollaboratorUrl from '@/assets/misc/img_remove-collaborator.svg'
import DocumentsDisabledIllustration from '@/components/SpotIllustration/DocumentsDisabledIllustration'

export interface DeleteDocumentsDialogProps {
  documentCount: number
  showing: boolean
  isPending: boolean
  onConfirm: () => unknown
  onDecline: () => unknown
  testId?: string
}

/**
 * Confirms permanently deleting one or more documents.
 */
export function DeleteDocumentsDialog({
  documentCount,
  showing,
  isPending,
  onConfirm,
  onDecline,
  testId,
}: DeleteDocumentsDialogProps) {
  const documentReference =
    documentCount > 1 ? 'these documents' : 'this document'
  return (
    <ConfirmSheet
      yes="Delete Forever"
      danger
      showing={showing}
      isPending={isPending}
      onConfirm={onConfirm}
      onDecline={onDecline}
      confirmButtonTestId={testId && `${testId}-confirm`}
      declineButtonTestId={testId && `${testId}-decline`}
      closeButtonTestId={testId && `${testId}-close`}
    >
      <ModalSheetContentBlock>
        <ModalSheetContentIllustration
          src={imgRemoveCollaboratorUrl}
          illustration={byDesign(undefined, DocumentsDisabledIllustration)}
          alt="Illustration of a women holding a phone with a crossed-out bubble above the phone."
        />
        <ModalSheetContentTitle>
          {`Are you sure you want to delete ${documentReference}?`}
        </ModalSheetContentTitle>
        <ModalSheetContentDescription>
          {`This action cannot be undone. Are you sure that you want to
            permanently delete ${documentReference}?`}
        </ModalSheetContentDescription>
      </ModalSheetContentBlock>
    </ConfirmSheet>
  )
}
